/* eslint-disable max-lines-per-function */
import React from "react";
import {
  Switch,
  Typography,
  Grid,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";
// import { useSnackbar } from "components/haven-design/snackbar";
import List from "@mui/material/List";
import IncomeBracket from "./income-bracket";


type Props = {
  propertyId: string;
  isAdmin?: boolean;
  isSupervisor?: boolean;
}

const sidebarOptions = [
  { alias: "hud", label: "HUD Based Rental Assistance" },
  { alias: "home", label: "HOME" },
  { alias: "lihtc", label: "Low Income Housing Tax Credit (LIHTC)" },
  { alias: "exempt", label: "Tax Exempt Bond" },
];

const incomeBrackets = [
  { alias: "thirty", label: "Extremely Low Income 30%" },
  { alias: "fifty", label: "Very Low Income 50%" },
  { alias: "eighty", label: "Low Income 80%" },
];

const FundingSources: React.FC<Props> = ({ isAdmin, isSupervisor }) => {
  // const { openSnackbar } = useSnackbar();

  // openSnackbar({ message: "Hey there" });

  if (!isAdmin && !isSupervisor) {
    return <Grid container spacing={2}>
      <Typography variant="h5">Only Supervisors can make changes to Funding Sources</Typography>
    </Grid>;
  }

  const [checked, setChecked] = React.useState<number[]>([]);
  const [active, setActive] = React.useState(0);

  const handleToggle = (value: number) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };
  const isActiveHOME = active === 1;
  return (<Grid container spacing={2}>
    <Grid size={{ xs: 12, md: 4, xl: 3 }}>
      <Typography variant="h6">Income Designations</Typography>
      <List>
        {sidebarOptions.map(({ label: value }, index) => {
          const labelId = `checkbox-list-secondary-label-${index}`;
          return (
            <ListItem key={`designation-${index}`}
              secondaryAction={<Switch
                edge="end"
                onChange={handleToggle(index)}
                checked={checked.indexOf(index) !== -1}
                inputProps={{ "aria-labelledby": labelId }}
              />}
            >
              <ListItemButton
                selected={index === active}
                onClick={() => setActive(index)}>
                <ListItemText id={labelId} primary={value} style={{ alignSelf: "flex-start" }}/>
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>

    </Grid>
    <Grid size={{ xs: 12, md: 8, xl: 9 }}>
      {isActiveHOME && <>
        <Typography variant="h6">HOME</Typography>
        <Typography variant="subtitle2">Choose your HOME designations</Typography>
        <Grid container spacing={2}>
          {incomeBrackets.map(({ alias, label: bracket }, idx) => (
            <IncomeBracket key={`bracket-${idx}`} title={bracket} alias={alias} />))}
        </Grid>
      </>}
    </Grid>
  </Grid>);
};

export default FundingSources;
